"use strict";

$(document).ready(function () {
  var items = document.getElementsByClassName('answer-btn');
  if (items.length != 0) {
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', openSchedulerbtnAnswerClick);
    }
  }
  waitForOpenSchedulerIframeLoad();
  //bindOpenSchedulerCallout();
});
function openSchedulerbtnAnswerClick(e) {
  //if next question
  if ($(this).data('nextquestion')) {
    var nextQuestionGUID = $(this).data('nextquestion');
    //hide all questions
    var allQuestions = document.querySelectorAll(".question");
    for (var i = 0; i < allQuestions.length; i++) {
      allQuestions[i].style.display = "none";
    }
    //parentQuestion.style.display = "none";

    //display new question
    var nextQuestion = document.getElementById(nextQuestionGUID);
    nextQuestion.style.display = "block";
    return;
  }

  //if scheduler
  if ($(this).data('scheduler') != "") {
    var scheudlerGUID = $(this).data('scheduler');
    //hide all questions
    var allQuestions = document.querySelectorAll(".question");
    for (var i = 0; i < allQuestions.length; i++) {
      allQuestions[i].style.display = "none";
    }

    //get scheduler ajax call
    var apiUrl = "/api/sitecore/openscheduleriframe/GetOpenSchedulers?guid=" + scheudlerGUID;
    makeRequest(apiUrl, "POST", null, null, function (xhttp, isNetworkSuccess) {
      if (isNetworkSuccess) {
        var data = JSON.parse(xhttp.responseText);
        if (data.openSchedulers.length > 1) {
          var selectDropdown = document.getElementById("openschedulers");
          var firstOption = new Option("Click to Select", "", true, false);
          selectDropdown.appendChild(firstOption);
          for (var x = 0; x < data.openSchedulers.length; x++) {
            var newOption = new Option(data.openSchedulers[x].Key, data.openSchedulers[x].Value, true, false);
            selectDropdown.appendChild(newOption);
          }

          //add options to select dropdown 
          var openSchedulerDropdown = document.getElementById("openscheduler-selection");
          openSchedulerDropdown.style.display = "inline-block";
          customDropdownInit();
        } else {
          var dropdown = document.getElementById("openschedulers");
          //document.getElementById('openSchedulerIframe').src = dropdown.value;
          var iFrameDiv = document.getElementById("OpenSchedulerContainer");

          //iFrameContainer.style.display = "block";
          var apikey = document.getElementById("OpenSchedulerApiKey");
          var url = document.getElementById("OpenSchedulerApi");
          var values = data.openSchedulers[0].Value.split("|");
          iFrameDiv.innerHTML = "";
          iFrameDiv.style.display = "block";
          mychartWidget.renderWidget({
            "url": "https://openscheduling.ynhhs.org/mychart-prd",
            "apiKey": apikey.value,
            "widgetType": "openscheduling",
            "containerId": "OpenSchedulerContainer",
            "additionalParams": {
              "vt": values[0],
              "dept": values[1],
              "id": values[2]
            }
          });
          waitForOpenSchedulerIframeLoad();
        }
      }
    });
    return;
  }

  //if no next question and no scheduler then show default content
  var allQuestions = document.querySelectorAll(".question");
  for (var i = 0; i < allQuestions.length; i++) {
    allQuestions[i].style.display = "none";
  }
  var notavailableContent = document.getElementById("OpenSchedulerNotAvailableContent");
  notavailableContent.style.display = "block";
}
function waitForOpenSchedulerIframeLoad() {
  var iframe = document.querySelectorAll('#OpenScheduler iframe');
  if (iframe.length > 0) {
    $('#OpenScheduler iframe').each(function () {
      $(this).attr('scrolling', 'yes');
    });
  } else {
    setTimeout(function () {
      //console.log('Delay for 1 second.');
      waitForOpenSchedulerIframeLoad();
    }, 5000);
  }
}
function selectOpenScheduler() {
  var dropdown = document.getElementById("openschedulers");
  //document.getElementById('openSchedulerIframe').src = dropdown.value;
  var iFrameDiv = document.getElementById("OpenSchedulerContainer");

  //iFrameContainer.style.display = "block";
  var apikey = document.getElementById("OpenSchedulerApiKey");
  var url = document.getElementById("OpenSchedulerApi");
  var values = dropdown.value.split("|");
  iFrameDiv.innerHTML = "";
  iFrameDiv.style.display = "block";
  mychartWidget.renderWidget({
    "url": "https://openscheduling.ynhhs.org/mychart-prd",
    "apiKey": apikey.value,
    "widgetType": "openscheduling",
    "containerId": "OpenSchedulerContainer",
    "additionalParams": {
      "vt": values[0],
      "dept": values[1],
      "id": values[2]
    }
  });
  waitForOpenSchedulerIframeLoad();
}